import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

const addOffer = gql`
mutation addOffer($title: String!, $companyname: String!, $address: String!, $description: String!, $createdate: DateTime!, $updatedate: DateTime!, $surveyId: ID) {
  createOffer(title: $title, companyname: $companyname, address:$address, description: $description, createdate: $createdate, updatedate: $updatedate, surveyId: $surveyId) {
    id,
    title,
    createdate
  }
}`;

const editOffer = gql`
mutation updateOffer($id: ID!, $title: String!, $companyname: String!, $address: String!, $description: String!, $updatedate: DateTime!) {
  updateOffer(id: $id, title: $title, companyname: $companyname, address:$address, description: $description, updatedate: $updatedate) {
    id,
    title,
    updatedate
  }
}`;

const addAnswer = gql`
mutation addAnswer($criteriaId: ID, $offerId: ID, $optionId: ID) {
  createAnswer(criteriaId: $criteriaId, offerId: $offerId, optionId: $optionId) {
    id
  }
}`;

const deleteOffer = gql`
mutation deleteOffer($id: ID!) {
  deleteOffer(id: $id) {
    id
  }
}`;

const getUserOffers = gql`
query ($email: String!) {
  User(email: $email){
    id,
    name,
    surveys{
        id,
        title,
        offers {
          id,
          title,
          address,
          createdate,
          answers {
            id,
            option {
              id,
              importance,
              },
            criteria {
                id,
                importance,
              }
          }
        }
      }
    }
}`;

const getVisionOffers = gql`
query ($surveyId: ID) {
  Survey(id: $surveyId){
    id,
    title,
      offers {
        id,
        title,
        address,
        companyname,
        description,
        createdate,
        answers {
          id,
          option {
            id,
            title,
            importance,
            },
          criteria {
              id,
              title,
              importance,
            }
        }
      }

    }
}`;
const getOfferShortDetails = gql`
query ($offerId: ID) {
  Offer(id: $offerId){
      id,
      title,
      address,
      createdate,
      surveyId {
        id
    }
  }
}`;
const getOptionAnswers = gql`
query ($optionId: ID) {
  allAnswers(filter: { option:{id: $optionId}}){
      id
  }
}`;
const getOfferAnswers = gql`
query ($offerId: ID) {
  allAnswers(filter: { offer:{id: $offerId}}){
      id,
      option {
        id,
        title,
        importance,
        },
      criteria {
          id,
          title,
          importance,
        }
    }
}`;

const getUserSurveyAnswers = gql`
query ($email: String) {
  allUsers(filter:{email: $email}){
    surveys{
      id,
      offers{
        id,
        answers{
          id,
        }
      }
    }
    }
}`;

const getOfferDetails = gql`
query ($offerId: ID) {
  Offer(id: $offerId){
      id,
      title,
      address,
      companyname,
      description,
      createdate,
      answers {
        id,
        option {
          id,
          title,
          importance,
          },
        criteria {
            id,
            title,
            importance,
          }
      }
    }
}`;

const getCoefs = gql`
query {
  allCoefs{
    id,
    importance,
    name,
    coef
  }
}`;

@Injectable()
export class JobService {


  constructor(private apollo: Apollo) { }

  addNewJob(title: string, surveyId: string, company: string, address: string, refrence: string) {
    return this.apollo.mutate({
      mutation: addOffer,
      variables: {
        title: title,
        address: address,
        surveyId: surveyId,
        companyname: company,
        description: refrence,
        createdate: new Date,
        updatedate: new Date,
      }
    });
  }

  editJob(id: string, title: string, company: string, address: string, refrence: string) {
    return this.apollo.mutate({
      mutation: editOffer,
      variables: {
        id: id,
        title: title,
        address: address,
        companyname: company,
        description: refrence,
        updatedate: new Date,
      }
    });
  }

  getCoefs() {
    return this.apollo.watchQuery<{ data }>({
      query: getCoefs,
    }).valueChanges.map(({ data }: any) => data);
  }

  addNewAnswer(criteriaId: string, offerId: string, optionId: string) {
    return this.apollo.mutate({
      mutation: addAnswer,
      variables: {
        criteriaId: criteriaId,
        offerId: offerId,
        optionId: optionId
      }
    });
  }

  getVisionOffers(surveyId: string) {
    return this.apollo.watchQuery<{ User }>({
      query: getVisionOffers,
      variables: {
        surveyId: surveyId
      },
      pollInterval: 1000,
    }).valueChanges.map(({ data }: any) => data);
  }

  getUserSurveyAnswers(email: string) {
    return this.apollo.watchQuery<{ User }>({
      query: getUserSurveyAnswers,
      variables: {
        email: email
      }
    }).valueChanges.map(({ data }: any) => data);
  }

  getVisionOffersAfterAdd(surveyId: string) {
    return this.apollo.watchQuery<{ User }>({
      query: getVisionOffers,
      variables: {
        surveyId: surveyId
      },
      fetchPolicy: 'network-only'
    }).valueChanges.map(({ data }: any) => data);
  }

  getOfferDetails(offerId: string) {
    return this.apollo.watchQuery<{ data }>({
      query: getOfferDetails,
      variables: {
        offerId: offerId
      }
    }).valueChanges.map(({ data }: any) => data);
  }

  getOfferDetailsAfterEdit(offerId: string) {
    return this.apollo.watchQuery<{ data }>({
      query: getOfferDetails,
      variables: {
        offerId: offerId
      },
      fetchPolicy: 'network-only'
    }).valueChanges.map(({ data }: any) => data);
  }

  getOfferShortDetails(offerId: string) {
    return this.apollo.watchQuery<{ data }>({
      query: getOfferShortDetails,
      variables: {
        offerId: offerId
      }
    }).valueChanges.map(({ data }: any) => data);
  }

  getOptionAnswers(optionId: string) {
    return this.apollo.watchQuery<{ data }>({
      query: getOptionAnswers,
      variables: {
        optionId: optionId
      }
    }).valueChanges.map(({ data }: any) => data);
  }

  getOfferAnswers(offerId: string) {
    return this.apollo.watchQuery<{ data }>({
      query: getOfferAnswers,
      variables: {
        offerId: offerId
      }
    }).valueChanges.map(({ data }: any) => data);
  }

  // add refetchQueries: [{ query: getOfferAnswers, variables: { offerId: offerId } },
  // { query: getOfferDetails, variables: { offerId: offerId } }]
  deleteOffer(offerId: string) {
    return this.apollo.mutate({
      mutation: deleteOffer,
      variables: {
        id: offerId,
      }
    });
  }

  // all mutations for edit-job
  buildDeleteOffer(offerId) {
    let index = 1;
    let deleteOfferString = ``;

    deleteOfferString += `
      deleteOffer${index}: deleteOffer(id: "${offerId}") {
          id
      }`;

    deleteOfferString += ``;
    return deleteOfferString;
  }
  buildAddAnswer(index, criteriaId, offerId, optionId) {
    const nowDate = new Date().toISOString();
    let addAnswerString = ``;
    addAnswerString = `
      addAnswer${index}: createAnswer(criteriaId: "${criteriaId}", offerId: "${offerId}", optionId: "${optionId}") {
          id,
      }`;
    addAnswerString += ``;
    return addAnswerString;
  }
  mutateEditOffer(mutateString: string) {
    const mutateEditOffer: any = gql`${mutateString}`;
    return this.apollo.mutate({
      mutation: mutateEditOffer
    }).map(({ data }: any) => data);
  }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/services/job.service.ts